/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SearchAccountWithStatsResponseItem { 
    id: string;
    name: string;
    amountInBtc?: number | null;
    activeWorkers?: number | null;
    offlineWorkers?: number | null;
    inactiveWorkers?: number | null;
}

